import { CommonFilter, useIsFilterApplied } from "@knowfully/ui.common";
import { useEffect, useState } from "react";
import { CatalogFilter } from "services/organizationPortalClient";

type SeriesFilterProps = {
  onChange: (filter: CatalogFilter) => void;
};

export default function SeriesFilter({ onChange }: SeriesFilterProps) {
  const [filter, setFilter] = useState({} as CatalogFilter);

  const isFilterApplied = useIsFilterApplied(filter, []);

  const onChangeInternal = (prop: keyof CatalogFilter, val: any) => {
    setFilter((prev) => ({ ...prev, [prop]: val }) as CatalogFilter);
  };

  // Auto-apply filters to parent on any change
  useEffect(() => {
    onChange(filter);
  }, [filter, onChange]);


  const clearFilter = () => {
    const emptyFilter = {} as CatalogFilter;
    setFilter(emptyFilter);
  };

  return (
    <CommonFilter
      searchText={filter.searchText}
      onSearchTextChange={(val: string | undefined) => onChangeInternal("searchText", val)}
      onClear={clearFilter}
      isFilterApplied={isFilterApplied}
    />
  );
}
